export default __webpack_public_path__ + "static/media/grafema_SET_17.e6295849.jpg";